import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchPiecesGestion, updateSearchPieceFilters } from 'store/pieceGestion/pieceGestionActions';
import PieceGestionSearchFilter from './PieceGestionSearchFilter';

class PieceGestionSearchFilterContainer extends React.Component {

    componentDidMount = () => {
        const { defautNumeroPiece, updateSearchPieceFilters } = this.props;
        // Si le numéro de pièce est renseigné on présélectionne la pièce
        if (defautNumeroPiece && defautNumeroPiece !== '') {
            let criteres = { ...this.props.criteres };
            criteres['numeroPiece'] = defautNumeroPiece;

            updateSearchPieceFilters(criteres);
        }
    }

    componentDidUpdate = (prevProps) => {
        const { fetchPiecesGestion, criteres, defautNumeroPiece, client, codeDepot, isLoading } = this.props;

        // Ne pas relancer si déjà en cours de chargement
        if (isLoading) {
            return;
        }

        // Lancer la recherche uniquement si le numéro de pièce vient d'être mis à jour
        const numeroPieceChanged = prevProps.criteres.numeroPiece !== criteres.numeroPiece;
        if (!!defautNumeroPiece && criteres.numeroPiece !== '' && numeroPieceChanged) {
            fetchPiecesGestion(client, codeDepot);
        }
    }

    handleSearch = () => {
        const { fetchPiecesGestion, client, criteres, codeDepot, onSearch } = this.props;

        if (criteres.typeRecherche !== 'piece' || criteres.numeroPiece !== '') {
            if (onSearch) onSearch();
            fetchPiecesGestion(client, codeDepot);
        }
    }

    handleChange = event => {
        let criteres = { ...this.props.criteres };
        criteres[event.target.name] = event.target.value;

        this.props.updateSearchPieceFilters(criteres);
    };

    render() {
        const { criteres, client, isLoading } = this.props;

        return (
            <PieceGestionSearchFilter
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                criteres={criteres}
                client={client}
                isLoading={isLoading}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    criteres: state.pieceGestion[ownProps.namespace].piecesGestion.criteres,
    isLoading: state.pieceGestion[ownProps.namespace].piecesGestion.isLoading
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    updateSearchPieceFilters: (criteres) => dispatch(updateSearchPieceFilters(ownProps.namespace, criteres)),
    fetchPiecesGestion: (client, codeDepot) => dispatch(fetchPiecesGestion(ownProps.namespace, client, codeDepot))
});

PieceGestionSearchFilterContainer.propTypes = {
    client: PropTypes.object,
    codeDepot: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(PieceGestionSearchFilterContainer);